import abstractModel from "../../core/MercatelyModel";
import { MERCATELY_API } from '../../constants/AppConstants';

let resource = `${MERCATELY_API}`;

const model = abstractModel(resource);

model.getGoals = async () => {
  const newResource = `${resource}/goals`;

  return model.get({}, { path: newResource });
};

export default model;
